import { t } from "@/i18n-js/instance";

import { FeatureRow } from "../FeatureRow";
import { SectionWrapper } from "./SectionWrapper";

export const BrandedApps = () => {
  const plusTalkToSales = t("pricing_plans.feature.talk_to_sales");

  return (
    <SectionWrapper sectionName={t("pricing_plans.section.branded_apps")}>
      <FeatureRow
        title={t("pricing_plans.feature.branded_apps.ios_and_android")}
        basic={false}
        professional={false}
        business={false}
        enterprise={false}
        plus={plusTalkToSales}
      />
      <FeatureRow
        title={t("pricing_plans.feature.branded_apps.custom_app_builder")}
        basic={false}
        professional={false}
        business={false}
        enterprise={false}
        plus={plusTalkToSales}
      />
      <FeatureRow
        title={t(
          "pricing_plans.feature.branded_apps.custom_welcome_experience",
        )}
        basic={false}
        professional={false}
        business={false}
        enterprise={false}
        plus={plusTalkToSales}
      />
      <FeatureRow
        title={t("pricing_plans.feature.branded_apps.push_notifications")}
        basic={false}
        professional={false}
        business={false}
        enterprise={false}
        plus={plusTalkToSales}
      />
      <FeatureRow
        title={t("pricing_plans.feature.branded_apps.native_payments")}
        basic={false}
        professional={false}
        business={false}
        enterprise={false}
        plus={plusTalkToSales}
      />
      <FeatureRow
        title={t("pricing_plans.feature.branded_apps.app_store")}
        basic={false}
        professional={false}
        business={false}
        enterprise={false}
        plus={plusTalkToSales}
      />
      <FeatureRow
        title={t("pricing_plans.feature.branded_apps.sdk")}
        basic={false}
        professional={false}
        business={false}
        enterprise={false}
        plus={plusTalkToSales}
      />
    </SectionWrapper>
  );
};
